import React from "react";
import { useTranslation } from "react-i18next";
import { deleteSheet } from "../actions";
import { ModalBuilder } from "@redriver/cinnamon";
import { withRouter } from "react-router-dom";
import { withCurrentUser } from "features/../../../shared/components/auth";
import { compose } from "redux";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { DropdownItem } from "semantic-ui-react";
import { withImpersonatedPermissions } from "modules/ImpersonatedUserPermissions";

const DeleteSheet = ({ sheet, onSubmitted }) => {
  const { t } = useTranslation("agreements");
  const { sheetId, sheetName } = sheet;
  // Auth checks done in SheetActions.js

  return (
    <ModalBuilder
      withForm
      submitAction={deleteSheet}
      submitParams={{ sheetId }}
      onSubmitted={onSubmitted}
      renderTrigger={(trigger) => (
        <DropdownItem onClick={trigger}>
          {t("SheetActions.DeleteSheet.TriggerText")}
        </DropdownItem>
      )}
      renderModal={(modalProps) => (
        <TranslatedModal
          {...modalProps}
          header={t("SheetActions.DeleteSheet.HeaderText")}
          size="small"
        >
          {t("SheetActions.DeleteSheet.ConfirmMessage", { sheetName })}
        </TranslatedModal>
      )}
    />
  );
};

export default compose(
  withCurrentUser,
  withImpersonatedPermissions,
)(withRouter(DeleteSheet));
